/* eslint-disable no-unused-vars */
import React, { useState, useMemo, useEffect } from 'react';
import { DashboardProvider } from '../Dashboard/useDashboard';
// MUI
import { Box } from '@mui/material';
// CONTEXT
import useProductSamplingv2Context from './context/useProductSamplingv2Context';
// COMPONENTS
import Header from './components/Header';
import RequestSummary from './components/RequestSummary';
import Table from './components/Table';
import moment from 'moment/moment';
import CreateNewPlanModal from './components/CreateNewPlanModal';
// API
import { getOverviewList, getOverviewSummaryList } from '../../api/productSamplingWorkflowApi';
export default function ProductSamplingOverview() {
  const defaultFilterForm = {
    month_year: moment().format('YYYY-MM'),
    status: 0,
    category_id: 0,
  };
  const [filterForm, setFilterForm] = useState(defaultFilterForm);
  const [overview, setOverview] = useState({ loading: false, items: [] });
  const [summary, setSummary] = useState({
    loading: false,
    plan_requested: 0,
    total_items: 0,
    requested_qty: 0,
    confirmed_qty: 0,
    category: [],
  });
  const [newPlan, setNewPlan] = useState({ toggle: false, loading: false, items: [] });

  const handleCreateNewPlan = () => {
    setNewPlan({ ...newPlan, toggle: true });
  };

  const loadOverviewList = async () => {
    setOverview({ ...overview, loading: true });
    const request = {
      month: moment(filterForm?.month_year).format('M'),
      year: moment(filterForm?.month_year).format('YYYY'),
      status_id: filterForm?.status,
      category_id: filterForm?.category_id,
    };

    const response = await getOverviewList(request);
    const { code, data } = response?.data;

    if (code === '200') {
      setOverview({ ...overview, loading: false, items: data });
    }
  };

  const loadOverviewSummary = async () => {
    setSummary({ ...summary, loading: true });
    const request = {
      month: moment(filterForm?.month_year).format('M'),
      year: moment(filterForm?.month_year).format('YYYY'),
    };

    const response = await getOverviewSummaryList(request);
    const { code, data } = response?.data;

    if (code === '200') {
      setSummary({
        ...summary,
        loading: false,
        plan_requested: data.plan_requested,
        total_items: data.total_items,
        requested_qty: data.requested_qty,
        confirmed_qty: data.confirmed_qty,
        category: data.category,
      });
    }
  };

  useEffect(() => {
    loadOverviewList();
    loadOverviewSummary();
  }, [filterForm]);

  return (
    <DashboardProvider>
      <useProductSamplingv2Context.Provider
        value={useMemo(
          () => ({
            overview,
            summary,
            filterForm,
            newPlan,
            setFilterForm,
            setNewPlan,
            handleCreateNewPlan,
          }),
          [filterForm, overview, summary, newPlan],
        )}
      >
        <Box
          sx={{
            bgcolor: '#fafafa',
            minHeight: '100vh',
            p: 3,
          }}
        >
          {/* Header */}
          <Header />
          {/* Request Summary */}
          <RequestSummary />
          {/* Table*/}
          <Table />
        </Box>
        {newPlan.toggle ? <CreateNewPlanModal /> : ''}
      </useProductSamplingv2Context.Provider>
    </DashboardProvider>
  );
}
